<!--
  This icon is designed especially for Concertgebouw and not from an icon set,
  so be careful reusing it in other projects.
  -->

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M7.8 4.8c2.6-.4 5.7-.4 8.3 0 2.4.3 4.2 2 4.5 3.8.4 2.2.4 4.8 0 6.9-.3 1.8-2.2 3.4-4.5 3.8-2.6.4-5.7.4-8.3 0-2.4-.3-4.2-2-4.5-3.8-.4-2.2-.4-4.8 0-6.9.4-1.8 2.2-3.5 4.5-3.8zm8.6-2c-2.8-.4-6.1-.4-8.9 0-3 .4-5.7 2.6-6.2 5.4-.5 2.4-.5 5.3 0 7.7.5 2.8 3.2 4.9 6.2 5.4 2.8.4 6.1.4 8.9 0 3-.4 5.7-2.6 6.2-5.4.5-2.4.5-5.3 0-7.7-.5-2.8-3.2-5-6.2-5.4zm-5.8 4.4c-.2-.1-.4-.2-.6-.2-.1 0-.3 0-.5.1-.1.1-.3.2-.4.4-.1.1-.1.3-.1.5v8c0 .2 0 .4.1.5.1.2.2.3.4.4.2.1.4.1.5.1.2 0 .4-.1.5-.2l6-4c.1-.1.2-.2.3-.4.2-.1.2-.2.2-.4s0-.3-.1-.5c-.1-.1-.2-.3-.3-.4l-6-3.9zm3.6 4.8L11 14.1V9.9l3.2 2.1z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
</template>
